import Body from "../capone/Body";

export default Body;
